<template>
  <div class="contractInfo">
    <QS-h4-title title="合同信息" />
    <!-- eslint-disable vue/no-unused-refs -->
    <el-form
      ref='contract_info_obj'
      :rules='contractInfo_rules'
      :model='contractInfo_obj'
    >
    <!-- eslint-enable -->
      <QS-column-box>
        <template>
          <el-form-item
            prop='contractNo'
            v-alphanumeric="true"
            :label="'业务合同编号' + columnSeparator"
          >
            <el-input
              v-model="contractInfo_obj.contractNo"
              v-deleteEmoji="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            prop='contractDate'
            label="合同起止日期:"
          >
            <el-date-picker
              style="width: 230px"
              v-model="contractInfo_obj.contractDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              :default-time="['00:00:00', '23:59:59']"
              @change="changeContractDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            prop='carTotalNum'
            :label="'采购车辆数' + columnSeparator"
          >
            <el-input
              v-model="contractInfo_obj.carTotalNum"
              v-number:integer="7"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            class="alone"
            prop='contractAttachment'
            :show-message="isUploadedFiles"
            :label="'合同附件' + columnSeparator"
          >
            <UploadCommon
              listType="text"
              :fileList="contractInfo_obj.contractAttachment"
              :limit="20"
              :sizeType="4"
              acceptType=".jpg,.pdf,.jpeg,.word,.excel,.png,.csv,.docx,.xlsx"
              commonUpload
              group="order"
              code="order_contract_attachment_file"
            />
          </el-form-item>
        </template>
      </QS-column-box>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 合同校验消息显示控制flag
      isUploadedFiles: false,
      // 合同信息
      contractInfo_obj: {
        contractDate: '',
        contractNo: '',
        contractStartDate: '',
        contractEndDate: '',
        contractAttachment: [],
        carTotalNum: '',
      },
      contractInfo_rules: {
        contractNo: [
          {
            required: true,
            message: '业务合同编号未填写',
            trigger: 'change',
          },
        ],
        contractAttachment: [
          {
            required: true,
            message: '合同附件未上传',
            trigger: 'change',
          },
        ],
        contractDate: [
          {
            required: true,
            message: '合同起止日期未选择',
            trigger: 'change',
          },
        ],
        carTotalNum: [
          {
            required: true,
            message: '采购车辆数未填写',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    'contractInfo_obj.contractAttachment': {
      handler(val) {
        // 附件数量大于0，提示关闭
        if (val.length > 0) {
          this.isUploadedFiles = false
        } else {
          this.isUploadedFiles = true
        }
      },
      deep: true,
    },
  },
  methods: {
    // 合同附件单独控制校验提示信息
    // eslint-disable-next-line vue/no-unused-properties
    validContract() {
      if (this.contractInfo_obj.contractAttachment.length > 0) {
        this.isUploadedFiles = false
      } else {
        this.isUploadedFiles = true
      }
    },
    changeContractDate(val) {
      this.contractInfo_obj.contractStartDate = val[0] || ''
      this.contractInfo_obj.contractEndDate = val[1] || ''
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
